"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Column = function Column() {
  return null;
};

exports.default = Column;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/Column.js
// module id = 828
// module chunks = 0